const STATUS_STYLES = {
  ACTIVE: "bg-secondary-container/70 text-secondary-on-container",
  INACTIVE: "bg-surface-container-highest text-on-surface-variant",
  SUSPENDED: "bg-error-container text-error-on-container",

  OPEN: "bg-tertiary-container/25 text-tertiary",
  ASSIGNED: "bg-primary-container/25 text-primary",
  UNDER_REVIEW: "bg-secondary-container/70 text-secondary-on-container",
  HOLD: "bg-surface-container-highest text-on-surface-variant",
  RESOLVED: "bg-secondary-container/70 text-secondary-on-container",
  REOPENED: "bg-error-container text-error-on-container",
};

const STATUS_LABELS = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  SUSPENDED: "Suspended",
  OPEN: "Open",
  ASSIGNED: "Assigned",
  UNDER_REVIEW: "Under review",
  HOLD: "On hold",
  RESOLVED: "Resolved",
  REOPENED: "Reopened",
};

export function StatusChip({ status }) {
  const style = STATUS_STYLES[status] ?? "bg-surface-container-highest text-on-surface-variant";
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-label-sm font-semibold ${style}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}

const PRIORITY_STYLES = {
  LOW: "bg-surface-container-highest text-on-surface-variant",
  MEDIUM: "bg-primary-container/25 text-primary",
  HIGH: "bg-tertiary-container/25 text-tertiary",
  URGENT: "bg-error-container text-error-on-container",
};

export function PriorityChip({ priority }) {
  const style = PRIORITY_STYLES[priority] ?? "bg-surface-container-highest text-on-surface-variant";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-label-sm font-semibold ${style}`}>
      {priority}
    </span>
  );
}
